<p-dialog *ngIf="standardTitle"
          header="{{ ('WS_DIRECTORY.STANDARD_TITLE.' + (standardTitle.id ? 'MODIFY_HEADER' : 'NEW_HEADER')) | translate }}"
          [(visible)]="display"

          [modal]="true"
          [draggable]="false"
          class="admin-dialog">
  <form [formGroup]="standardTitleForm" (submit)="save()">
    <div class="ui-g service-edit-dialog">
      <div class="ui-g-12">
        <div class="ui-g m-b-0">
          <div class="ui-g-5">
            <label>{{ 'WS_DIRECTORY.STANDARD_TITLE.MODIFY.TRANSLATION' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <p-dropdown [options]="languageItems"
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="selectedLocaleCode"></p-dropdown>
          </div>
          <div class="ui-g-12"  *ngFor="let name of standardTitle.names ">
            <div class="ui-g m-b-0" *ngIf="name.langCode === selectedLocaleCode">
              <div class="ui-g-5">
                <label>{{ 'WS_DIRECTORY.STANDARD_TITLE.MODIFY.NAME' | translate }}</label>
              </div>
              <div class="ui-g-7">
                <input pInputText [ngModelOptions]="{standalone: true}" [(ngModel)]="name.value">
              </div>
            </div>
          </div>
          <div class="ui-g-5">
            <label>{{ 'WS_DIRECTORY.STANDARD_TITLE.IS_OFFICIAL' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <p-checkbox formControlName="official" binary="true" class="m-t-10"></p-checkbox>
          </div>
          <div class="ui-g-5">
            <label>{{'WS_DIRECTORY.STANDARD_TITLE.MODIFY.ORDER' | translate}}</label>
          </div>
          <div class="ui-g-7">
            <gs-extended-input [control]="standardTitleForm.get('order')">
              <input pInputText type="number" min="0" formControlName="order">
            </gs-extended-input>
          </div>
          <div class="ui-g-offset-5 ui-g-7">
            <button pButton class="ui-button-success m-r-15 inline-block"
                    type="submit"
                    [label]="'WS_DIRECTORY.SAVE' | translate"></button>
            <button pButton class="ui-button-secondary inline-block"
                    type="button"
                    [label]="'WS_DIRECTORY.DISCARD' | translate" (click)="discard()"></button>
          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
